import { useRef, useEffect } from "react";
import usePrintDocument from "../../usePrintDocument";
import "./PdfOrcamentoStyle.scss";
import moment from "moment/moment";
import Cabecalho from "../../components/Cabecalho";
import Rodape from "../../components/Rodape";
import ObservacoesOrtodontia from "../../components/ObservacoesOrtodontia";

function PdfOrcamentoParticular({ orcamentoData, showSingleP }) {
  let subTotal = 0;
  orcamentoData.serviceList.forEach((el) => {
    subTotal += el.valor_cliente;
  });

  const version2 = orcamentoData.clinica._id === "6817794da65ef747fc74730d";

  const total = subTotal - orcamentoData.desconto;
  const componentRef = useRef();

  const handlePrint = usePrintDocument({
    contentRef: componentRef,
    documentTitle: `Orçamento-${orcamentoData.cliente.nome}_${moment(
      new Date(),
    ).format("DD-MM-YYYY")}`,
    onAfterPrint: () => {
      showSingleP();
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    handlePrint();
  }, [handlePrint]);

  orcamentoData.serviceList.forEach((sl) => {
    if (!sl.faces) {
      sl = { ...sl, faces: "" };
    }
  });

  const radiografia = orcamentoData.serviceList.find(
    (el, index) => el.tratamento.designacao === "Radiografia",
  );

  return (
    <>
      <div
        ref={componentRef}
        className={`pdf-orcamento-wrapper ${orcamentoData.clinica?.configuracoes?.configuracoes?.impressaoPretoEBranco?.ativo ? " pdf-orcamento-wrapper--pretoebranco" : ""}`}
      >
        {orcamentoData.clinica.cabecalhoRodape?.cabecalho &&
        orcamentoData.clinica.cabecalhoRodape?.orcamentoParticular ? (
          <div className="pdf-orcamento-cabecalhoBanner__container">
            <Cabecalho
              linkImg={orcamentoData.clinica.cabecalhoRodape?.cabecalho}
            />
          </div>
        ) : (
          <div className="pdf-orcamento-cabecalho">
            <div className="pdf-orcamento-cabecalho-left">
              <img
                src={`${process.env.REACT_APP_BACKEND_LINK}/${orcamentoData.clinica.logotipo}`}
                alt=""
              />
            </div>

            <div className="pdf-orcamento-cabecalho-right">
              <span>{orcamentoData.clinica.nome}</span>
              <span>
                {orcamentoData.medico_responsavel.genero === "masculino"
                  ? "Dr. "
                  : "Dra. "}
                {orcamentoData.medico_responsavel.name}/
                {orcamentoData.medico_responsavel.profissao}
              </span>
              <span>
                Telef: {orcamentoData.clinica.contacto}
                {orcamentoData.clinica.contacto2
                  ? "/" + orcamentoData.clinica.contacto2
                  : ""}
                {orcamentoData.clinica.contacto3
                  ? "/" + orcamentoData.clinica.contacto3
                  : ""}
              </span>
              <span>{orcamentoData.clinica.endereco}</span>
              <span>NIF: {orcamentoData.clinica.nif}</span>
            </div>
          </div>
        )}
        <div className="pdf-orcamento-dadosEOdontograma">
          <div className="pdf-orcamento-outrosDados">
            <h1 className="pdf-orcamento-outrosDados__titulo">
              Prescrição/Orçamento Estomatológico
            </h1>
            <hr className="pdf-orcamento-outrosDados__line" />
            <div className="pdf-orcamento-outrosDados__dadosDuplos">
              <div className="pdf-orcamento-outrosDados__dadosSimples">
                <span className="pdf-orcamento-outrosDados__cabecalhoBold">
                  Nº:{" "}
                </span>
                <span>{`${
                  orcamentoData.numero
                }/${new Date().getFullYear()}`}</span>
              </div>
              <div className="pdf-orcamento-outrosDados__dadosSimples">
                <span className="pdf-orcamento-outrosDados__cabecalhoBold">
                  DATA:{" "}
                </span>
                <span>
                  {orcamentoData.transformado
                    ? orcamentoData.dataAprovacao
                      ? moment(orcamentoData.dataAprovacao).format("DD/MM/YYYY")
                      : moment(orcamentoData.created_at).format("DD/MM/YYYY")
                    : moment().format("DD/MM/YYYY")}
                </span>
              </div>
            </div>
            <div className="pdf-orcamento-outrosDados__dadosSimples">
              <span className="pdf-orcamento-outrosDados__cabecalhoBold">
                NOME DO PACIENTE:{" "}
              </span>
              <span>{orcamentoData.cliente.nome}</span>
            </div>
            <div className="pdf-orcamento-outrosDados__dadosSimples">
              <span className="pdf-orcamento-outrosDados__cabecalhoBold">
                NIF:{" "}
              </span>
              <span>
                {orcamentoData.cliente.nif ? orcamentoData.cliente.nif : ""}
              </span>
            </div>
            <div className="pdf-orcamento-outrosDados__dadosSimples">
              <span className="pdf-orcamento-outrosDados__cabecalhoBold">
                CATEGORIA DE BENEFICIÁRIO:{" "}
              </span>
              <span>Particular</span>
            </div>
            <hr className="pdf-orcamento-outrosDados__line" />
          </div>
          <div className="odontograma-container">
            <img src="/images/odontograma.png" alt="" />
          </div>
        </div>
        <div className="divTabela">
          <table>
            <tbody>
              <tr className="headingLine">
                <th className="pdf-orc-left">Designação</th>
                <th>Qtd.</th>
                <th className="pdf-orc-center">Dentes</th>
                <th>Pr. Unit.</th>
              </tr>
              {orcamentoData.serviceList.map((el, i) => (
                <tr
                  className={`${
                    i === 0 ? "primeiraLinha normalLine" : "normalLine"
                  }`}
                  key={i}
                >
                  <td className="pdf-orc-left">
                    {el.tratamento.designacao} {" " + el.faces}
                  </td>
                  <td>1</td>
                  <td className="pdf-orc-center">{el.dente}</td>

                  <td>{Intl.NumberFormat("pt-BR").format(el.valor_cliente)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div
          className={`orcamento-rodape ${
            version2 ? "orcamento-rodape--versionClientSignature" : ""
          }`}
        >
          <hr className="orcamento-rodape__linha" />{" "}
          {version2 ? (
            <div
              className="orcamento-rodape__leftVersionClientSignatureContainer"
              style={{ paddingTop: "10px" }}
            >
              <span className="orcamento-rodape__leftVersionClientSignatureContainer__text">
                O Cliente
              </span>
              <span className="orcamento-rodape__leftVersionClientSignatureContainer__text">
                O Clínico
              </span>
              <hr className="orcamento-rodape__leftVersionClientSignatureContainer__hr" />
              {orcamentoData.medico_responsavel?.assinatura?.ativa &&
              orcamentoData.medico_responsavel?.assinatura?.autorizacoes
                ?.orcamentos &&
              orcamentoData.medico_responsavel?.assinatura?.imagem ? (
                <img
                  src={`${process.env.REACT_APP_BACKEND_LINK}/${orcamentoData.medico_responsavel.assinatura.imagem}`}
                  alt="Assinatura"
                  className="assinatura-img"
                  style={{
                    maxHeight: "60px",
                    maxWidth: "180px",
                    objectFit: "contain",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              ) : (
                <hr className="orcamento-rodape__leftVersionClientSignatureContainer__hr" />
              )}
            </div>
          ) : (
            <div className="orcamento-rodape--left">
              <span className="orcamento-rodape--left__text">O Clínico</span>
              {orcamentoData.medico_responsavel?.assinatura?.ativa &&
              orcamentoData.medico_responsavel?.assinatura?.autorizacoes
                ?.orcamentos &&
              orcamentoData.medico_responsavel?.assinatura?.imagem ? (
                <img
                  src={`${process.env.REACT_APP_BACKEND_LINK}/${orcamentoData.medico_responsavel.assinatura.imagem}`}
                  alt="Assinatura"
                  className="assinatura-img"
                  style={{
                    maxHeight: "60px",
                    maxWidth: "180px",
                    objectFit: "contain",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              ) : (
                <hr className="orcamento-rodape--left__hr" />
              )}
            </div>
          )}
          <div className="orcamento-rodape--right">
            <div className="orcamento-rodape__div">
              <span className="orcamento-rodape--right__lineTitle">
                SubTotal Orçamento
              </span>
              <span className="valor_65px">
                {Intl.NumberFormat("pt-BR").format(subTotal)}
              </span>
            </div>
            <div className="orcamento-rodape__div">
              <span className="orcamento-rodape--right__lineTitle">
                Desconto
              </span>
              <span className="valor_65px">
                {Intl.NumberFormat("pt-BR").format(orcamentoData.desconto)}
              </span>
            </div>
            <div className="orcamento-rodape__div">
              <span className="orcamento-rodape--right__lineTitle">
                Total Orçamento
              </span>
              <span className="valor_65px">
                {Intl.NumberFormat("pt-BR").format(Math.max(0, total))}
              </span>
            </div>
          </div>
          {version2 ? (
            <div className="orcamento__consentimento__container">
              <strong>Consentimento Informado</strong>
              <br />
              Declaro que estou ciente do planeamento e dos procedimentos
              odontológicos(
              <span className="consentimento__procedimento">
                <input type="checkbox" className="consentimento__checkbox" />
                Anestesia
              </span>
              {radiografia ? (
                <>
                  <span className="consentimento__procedimento">
                    ,
                    <input
                      type="checkbox"
                      className="consentimento__checkbox"
                    />
                    RX infraoral
                  </span>
                </>
              ) : (
                <></>
              )}
              ) a serem realizados no meu caso e que recebi todas as explicações
              referentes a prazos, peculiaridades, limitações e desconfortos,
              aceitando-as. Também declaro que o respondido acima é verdadeiro.
            </div>
          ) : (
            <></>
          )}

          <ObservacoesOrtodontia serviceList={orcamentoData.serviceList} />
          {orcamentoData.clinica?.configuracoes?.configuracoes
            ?.validadeOrcamentos?.ativo === true && (
            <div
              className={`orcamento__msgValidade ${
                orcamentoData.clinica.cabecalhoRodape?.rodape &&
                orcamentoData.clinica.cabecalhoRodape?.orcamentoParticular
                  ? ""
                  : "orcamento__msgValidade__unico"
              }`}
            >
              {orcamentoData.clinica?.configuracoes?.configuracoes
                ?.validadeOrcamentos?.ativo === true &&
                `Nota: Este orçamento é válido por ${
                  orcamentoData.clinica?.configuracoes?.configuracoes
                    ?.validadeOrcamentos.validade || 30
                } dias a contar da data de emissão.`}
            </div>
          )}
          <div
            className={`orcamento__htSignature ${
              orcamentoData.clinica?.configuracoes?.configuracoes
                ?.validadeOrcamentos?.ativo === true
                ? ""
                : "orcamento__htSignature__comMargem"
            }`}
          >
            OdontoHT — Gestão inteligente para clínicas dentárias · by
            HealthTech CV
          </div>
          {orcamentoData.clinica.cabecalhoRodape?.rodape &&
            orcamentoData.clinica.cabecalhoRodape?.orcamentoParticular && (
              <div
                style={{ gridColumn: "1/-1" }}
                className="pdf-orcamento-rodapeBanner__container"
              >
                <Rodape
                  linkImg={orcamentoData.clinica.cabecalhoRodape?.rodape}
                />
              </div>
            )}
        </div>
      </div>
    </>
  );
}

export default PdfOrcamentoParticular;
